<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" v-if="viewDirs">
                <b-button @click="clickBtnStyleList('newDir')" variant="primary" size="sm" class="mb-1" v-b-popover.hover="'Nueva carpeta'">
                    <font-awesome-icon icon="folder-plus" />
                </b-button>
            </li>
        <!-- Breadcrumb Menu-->
            <li class="breadcrumb-menu">
                <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                    <button v-if="viewList" @click="clickBtnStyleList('list')" class="btn"><i class="icon-list icons"></i></button>
                    <button v-if="viewBlocks" @click="clickBtnStyleList('block')" class="btn"><i class="icon-grid icons"></i></button>
                    <button @click="clickBtnStyleList('filter')" class="btn">
                       <font-awesome-icon icon="filter" />
                    </button>
                    
                </div>
            </li>
        </ol>
    </nav>
</template>
<script>
import RecursoService from '@/services/recurso.service';
export default {
    name:'NavContent',
    data() {
        return {
            
        }
    },
    methods: {
        clickBtnStyleList(type) {

            this.$emit('styleList',type);
        }
    },
    props: {
        viewDirs: {
            type: Boolean,
            default: false
        },
        viewBlocks: {
            type: Boolean,
            default: true
        },
        viewList: {
            type: Boolean,
            default: true
        }
    }
}
</script>
<style lang="scss" scoped>
ol.breadcrumb{
    padding: 0 !important;
}
</style>